import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { pick } from 'lodash';
import type { UpdateAssetMutation, AssetInput } from '#/graphql/types';
import { updateAsset } from '#/graphql/mutations';
import fields from '../utils/mutationDataFields';
import { GET_ASSET } from './useAssetQuery';

const q = gql(updateAsset);

const useAssetUpdate = () => {
  const [mutation, result] = useMutation<UpdateAssetMutation>(q);
  const updateAsset = useCallback(
    async (itemId: string, asset: AssetInput) => {
      const response = await mutation({
        variables: {
          id: itemId,
          data: pick(asset, fields),
        },
        refetchQueries: [{ query: GET_ASSET, variables: { id: itemId } }],
        awaitRefetchQueries: true,
      });

      return response.data?.updateAsset?.data ?? undefined;
    },
    [mutation],
  );

  return { updateAsset, result };
};

export default useAssetUpdate;
